/**
 * @module app.ae
 * @preferred
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AppModule } from 'app/shared/config/modules';

@autoinject()
export class AutomationEngineModule extends AppModule {

    public readonly code = 'ae';

    constructor(private readonly logger: AppLogger) {
        super();

        logger.source = this;
    }

    public getTranslationNamespaces(): ReadonlyArray<string> {
        return ['ae'];
    }
}
